import { render, staticRenderFns } from "./watermark.vue?vue&type=template&id=7a2f804a&"
import script from "./watermark.vue?vue&type=script&lang=js&"
export * from "./watermark.vue?vue&type=script&lang=js&"
import style0 from "./watermark.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports